
// Home 

export const dataCarouselHome = [
  {
    image: "/public/assets/main_slider_home/serie-b.jpg",
    title: "EL PUNTO DE ENTRADA A LA CALIDAD ALPINE",
    description:
      "Disfruta de tu música favorita con el sonido claro y equilibrado de la nueva Serie B",
    buttontext: "VER PRODUCTOS",
    buttonlink: "https://alpine-lat.com/productos/altavoces/serie-b",
  },
  {
    image: "/public/assets/main_slider_home/alpine-status.jpg",
    title: "TU MÚSICA A UN NIVEL COMPLETAMENTE NUEVO",
    description: "Una performance superior para disfrutar de un sonido real",
    buttontext: "",
    buttonlink: null,
  },
  {
    image: "/public/assets/main_slider_home/optim8.jpg",
    title: "OPTIM-IZA TU AUDIO",
    description:
      "Mide, ajusta y optimiza sin esfuerzo cualquier sistema de audio con el OPTIM™",
    buttontext: "VER PRODUCTOS",
    buttonlink:
      "https://alpine-lat.com/productos/procesadores-de-audio/optim",
  },
];
